
import { useState } from "react";
import { motion } from "framer-motion";
import { RecipeJournal } from "@/components/RecipeJournal";
import { JournalEntries } from "@/components/JournalEntries";
import { useSearchParams } from "react-router-dom";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { CookingPot, BookOpen, UtensilsCrossed, ChefHat } from "lucide-react";

const Journal = () => {
  const [searchParams] = useSearchParams();
  const initialTab = searchParams.get('tab') || 'entries';

  return (
    <div className="min-h-screen bg-gradient-to-br from-[#FFE29F] via-[#FFA99F] to-[#FF719A]">
      <div className="container px-4 sm:px-6 py-8 sm:py-12">
        <div className="bg-white/90 backdrop-blur-sm rounded-lg p-6">
          <div className="max-w-5xl mx-auto space-y-8">
            <motion.div
              initial={{ opacity: 0, y: -20 }}
              animate={{ opacity: 1, y: 0 }}
              className="text-center"
            >
              <h1 className="text-3xl font-bold text-primary">Your Cooking Journey</h1>
              <p className="text-gray-600 mt-2">Track your culinary adventures and remember what you've learned</p>
              <div className="flex justify-center items-center gap-3 mt-4">
                <ChefHat className="h-6 w-6 text-amber-500" />
                <UtensilsCrossed className="h-6 w-6 text-rose-500" />
                <CookingPot className="h-6 w-6 text-emerald-500" />
              </div>
            </motion.div>
            
            <Tabs defaultValue={initialTab} className="w-full">
              <TabsList className="grid w-full grid-cols-2 mb-8">
                <TabsTrigger value="entries" className="data-[state=active]:bg-primary data-[state=active]:text-primary-foreground">
                  <BookOpen className="mr-2 h-4 w-4" />
                  Your Journal Entries
                </TabsTrigger>
                <TabsTrigger value="new" className="data-[state=active]:bg-primary data-[state=active]:text-primary-foreground">
                  <CookingPot className="mr-2 h-4 w-4" />
                  Add New Entry
                </TabsTrigger>
              </TabsList>
              
              <TabsContent value="entries">
                <motion.div
                  initial={{ opacity: 0, y: 20 }}
                  animate={{ opacity: 1, y: 0 }}
                >
                  <JournalEntries />
                </motion.div>
              </TabsContent>
              
              <TabsContent value="new">
                <motion.div
                  initial={{ opacity: 0, y: 20 }}
                  animate={{ opacity: 1, y: 0 }}
                >
                  <RecipeJournal />
                </motion.div>
              </TabsContent>
            </Tabs>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Journal;
